var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.6 29.6",
    style: {
      enableBackground: "new 0 0 29.6 29.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2215 -0.9752 0.9752 0.2215 -2.875 25.9254)",
    cx: 14.8,
    cy: 14.8,
    rx: 14.6,
    ry: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,21.7h1.6l-10.2-14H8.8L19.1,21.7z M20.1,6.1H23l-6.2,7.4l7.3,10h-5.7l-4.5-6.1l-5.1,6.1H5.9l6.7-7.9 l-7-9.5h5.9l4.1,5.6L20.1,6.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXTwitterLogo);
export default __webpack_public_path__ + "static/media/X_Twitter_Logo.5d6a28981f4f3fc28d85a740b27e0ced.svg";
export { ForwardRef as ReactComponent };